import { styled, Typography } from '@mui/material';

export const TreeViewFolderName = styled(Typography)(() => ({
    fontSize: '15px',
    fontStyle: 'normal',
    fontWeight: '700',
    lineHeight: 'normal',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
}));

export const TreeViewAttachmentName = styled(Typography)(() => ({
    fontSize: '15px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: 'normal',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
}));
